module.exports = __webpack_public_path__ + "static/img/influence1.ab7d9471.jpg";